var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 12H22C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C14.4701 2 16.7933 2.90232 18.5887 4.47664L19.8005 3.62817C20.137 3.3925 20.5984 3.64085 20.5871 4.05157L20.4526 8.91357C20.4434 9.24823 20.1142 9.47942 19.7963 9.37462L15.1665 7.84855C14.7756 7.71971 14.6991 7.20017 15.0363 6.96411L16.4589 5.96795C15.1905 5.02856 13.6394 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5C16.1421 19.5 19.5 16.1421 19.5 12Z",
    fill: "#8A94A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5657 8.46165C13.5457 8.20115 13.3285 8 13.0672 8H12.9827C12.7258 8 12.5107 8.19465 12.4852 8.45025L12.0302 13L8.78214 14.856C8.62635 14.9451 8.53021 15.1107 8.53021 15.2902V15.3454C8.53021 15.6751 8.84369 15.9145 9.16176 15.8278L13.6315 14.6087C13.8629 14.5456 14.0169 14.3271 13.9985 14.088L13.5657 8.46165Z",
    fill: "#8A94A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwaiting);
export default __webpack_public_path__ + "static/media/awaiting.a2370efb1c001f8c1b4279e3dd614aae.svg";
export { ForwardRef as ReactComponent };